// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { lastDayOfWeek as fn } from "../lastDayOfWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const lastDayOfWeekWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default lastDayOfWeekWithOptions;
